import React from 'react';
import Card from "components/card";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import {IoMdOpen} from "react-icons/io";
import { FaFileDownload } from "react-icons/fa";


function ColumnsTable(props) {
  const { columnsData, tableData,  tableName, onActionClick,  viewReport } = props;
  const [sorting, setSorting] = React.useState([]);

    const rightAlignedColumns = new Set(["MOEDA", "KWANZAS"]);

  let defaultData = tableData;
  const columns = columnsData.map((col) =>
      columnHelper.accessor(col.accessor, {
        id: col.accessor,
        header: () => (
            <p className="text-sm font-bold text-gray-600 dark:text-white">
              {col.Header}
            </p>
        ),
        cell: (info) => (
            <p className="text-sm font-bold text-navy-700 dark:text-white">
              {col.Header == "Editar" ? "Edit" : info.getValue()}
            </p>
        ),
      })
  );
  const [data, setData] = React.useState(() => [...defaultData]);

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  return (
    <Card extra={"w-full pb-3 p-3 h-full"}>
      <div className="overflow-x-scroll">
      <div className="text-xl font-bold text-navy-700 dark:text-white">
      {tableName}
        </div>
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="!border-px !border-gray-400">
                {headerGroup.headers.map((header) => {
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className="cursor-pointer border-b-[1px] border-gray-200 pt-4 pb-2 pr-4 text-start"
                    >
                      <div className="items-center justify-between text-xs text-gray-200">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {table
              .getRowModel()
              .rows.slice(0, 50)
              .map((row) => {

                return (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td
                          key={cell.id}
                          className={`min-w-[50px] border-white/0 py-3  pr-3 ${
                              rightAlignedColumns.has(cell.column.id) ? "text-right" : ""
                          }`}
                        >
                            {cell.column.id === "action" ? (
                                <button onClick={() => onActionClick(row.original)}>
                                    <IoMdOpen />
                                </button>
                            ) : cell.column.id === "report" && 
                            !row.original.accountNumber.startsWith("CAIXA ") ? (
                              <button onClick={() => viewReport(row.original)}>
                                  <FaFileDownload />
                              </button>
                          ) : 
                                                 
                          (
                                flexRender(cell.column.columnDef.cell, cell.getContext())
                            )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}

export default ColumnsTable;
const columnHelper = createColumnHelper();
